import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DialogRef } from '@progress/kendo-angular-dialog';

@Component({
    // Angular 16 derives a component ID from the metadata; without a selector this dialog and
    // ConfirmTwoOptionsDialogComponent got the same ID (NG0912) because their templates nearly match.
    selector: 'app-confirm-dialog',
    template: `
        <div class="modal-header">
            <h4 class="modal-title">{{ title }}</h4>
            <button class="close" type="button" aria-label="Close" (click)="activeModal.close(false)">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body" [innerHTML]="message"></div>
        @if (yesButtonName || noButtonName || cancelButtonName) {
            <div class="modal-footer">
                @if (yesButtonName) {
                    <button class="btn btn-sm btn-primary" preventMultiClick (click)="activeModal.close(true)">
                        {{ yesButtonName }}
                    </button>
                }
                @if (noButtonName) {
                    <button class="btn btn-sm btn-secondary" (click)="activeModal.close(false)">
                        {{ noButtonName }}
                    </button>
                }
                @if (cancelButtonName) {
                    <button class="btn btn-sm btn-secondary" (click)="activeModal.close(false)">
                        {{ cancelButtonName }}
                    </button>
                }
            </div>
        } @else {
            <div class="modal-footer">
                <button class="btn btn-sm btn-primary mr-2" preventMultiClick (click)="activeModal.close(true)">
                    <fa-icon [icon]="['fas', 'check']"></fa-icon>
                    &nbsp;&nbsp;{{ 'Yes' | translate }}
                </button>
                <button class="btn btn-sm btn-secondary" (click)="activeModal.close(false)">
                    <fa-icon [icon]="['fas', 'times']"></fa-icon>
                    &nbsp;&nbsp;{{ 'Cancel' | translate }}
                </button>
            </div>
        }
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ConfirmDialogComponent {
    public title: string;
    public message: string;
    public yesButtonName: string;
    public noButtonName: string;
    public cancelButtonName: string;

    constructor(public activeModal: DialogRef) {}
}
